module.exports = __webpack_public_path__ + "img/cx_icon.24890fb.png";